/**
 * School pages live at /{school}/{page}. The school is read from the URL once at startup; opening a
 * different school loads the app again, so no data from one school lingers in another's tab.
 */

/** First path segments that aren't schools. */
const ROOT_PATHS = new Set(['', 'login', 'platform', 'sign-up', 'verify-email', 'reset-password']);

export function schoolFromPath(pathname: string) {
  const first = pathname.split('/')[1] ?? '';
  let slug: string;
  try {
    slug = decodeURIComponent(first).toLowerCase();
  } catch {
    return null;
  }
  return ROOT_PATHS.has(slug) || !/^[a-z0-9-]{1,48}$/.test(slug) ? null : slug;
}

/** The school this tab is working in, or null on Edvora-wide pages (/login, /platform, /sign-up). */
export const currentSchool = schoolFromPath(window.location.pathname);

/** A page in a school, e.g. schoolHref('lincoln-academy', '/assets') → /lincoln-academy/assets. */
export function schoolHref(slug: string, path = '/') {
  const page = path === '/' ? '' : path.startsWith('/') ? path : `/${path}`;
  return `/${slug}${page}`;
}

/** Leaves the current school (or the Edvora-wide pages) for another school's page. */
export function openSchool(slug: string, path = '/') {
  window.location.assign(schoolHref(slug, path));
}
